import { Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';

import styles from './mimSidekickMessage.module.scss';

type MimSidekickMessageProps = {
  role: 'user' | 'assistant' | 'system';
  text: string;
};

export const MimSidekickMessage = ({
  role,
  text,
}: MimSidekickMessageProps): JSX.Element => {
  const isUser = role === 'user';
  return (
    <div
      className={classNames(styles.bubble, {
        [styles.bubbleUser]: isUser,
        [styles.bubbleAssistant]: !isUser,
      })}
    >
      <Text.Paragraph>{text}</Text.Paragraph>
    </div>
  );
};
